import {
  formatDate,
  monAndDayFormat,
  monDayAndTimeFormat,
  parseDate,
  toNumber,
} from "helpers";
import { fromCohortedEventName } from "model/reporterDb/dbTableCampaign";
import { GRANULARITY_TYPES } from "model/reporterDb/granularity";
import * as R from "ramda";
import { EVENTS_N_METRICS_NORMALIZATION } from "../normalization";

export const normalizeChartData =
  (granularityValue?: GRANULARITY_TYPES, dateKey = "date") =>
  (data) =>
    R.mapObjIndexed((val, key) => {
      if (key === dateKey) {
        return formatDate(
          parseDate(data[dateKey]),
          granularityValue === GRANULARITY_TYPES.HOURS
            ? monDayAndTimeFormat
            : monAndDayFormat
        );
      }

      let normalized = val;
      if (EVENTS_N_METRICS_NORMALIZATION[key]) {
        normalized = toNumber(
          EVENTS_N_METRICS_NORMALIZATION[key](val, undefined, undefined, data),
          0
        );
      } else {
        const [cohEvent, coh] = fromCohortedEventName(key);
        if (cohEvent && coh) {
          //try check whether it's cohorted
          normalized = toNumber(
            EVENTS_N_METRICS_NORMALIZATION[cohEvent]?.(
              val,
              undefined,
              undefined,
              data
            ) ?? val,
            0
          );
        }
      }

      return normalized;
    }, data);
